module.exports = __webpack_public_path__ + "img/mail.24bf4262.svg";